import { Component, Input } from '@angular/core';

@Component({
  selector: 'nns-loader',
  template: `
    <img src="./dist/assets/loader-32.png">
  `,
  styles: [`
    :host {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    img {
      animation: 4s linear 0s infinite rotateAnimation;
    }
    @keyframes rotateAnimation { from { transform: rotate(0); } to { transform: rotate(360deg); }  }
  `]
})
export class LoaderComponent {
}
